import { render, staticRenderFns } from "./closeDocumentAccount.vue?vue&type=template&id=7a82c27d&"
import script from "./closeDocumentAccount.vue?vue&type=script&lang=js&"
export * from "./closeDocumentAccount.vue?vue&type=script&lang=js&"
import style0 from "./closeDocumentAccount.vue?vue&type=style&index=0&id=7a82c27d&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports